import React from 'react';
import { Box, Container, Stack, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import siteText from '../content/siteText.json';
import SectionCard from './SectionCard';

const Contact = () => {
    const { contact, practice } = siteText;

    const splitRowSx = {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row-reverse' },
        gap: 4,
        alignItems: 'stretch',
        mb: 4
    };

    return (
        <Container
            maxWidth={false}
            sx={{
                py: { xs: 4, md: 7 },
                width: 'min(92vw, 1600px)',
                mx: 'auto'
            }}
        >
            <SectionCard title={contact.title} sx={{ width: '100%', mb: 4 }}>
                <Typography
                    variant="body1"
                    sx={{
                        color: 'rgba(0, 71, 110, 0.82)',
                        lineHeight: 1.85,
                        mb: 3
                    }}
                >
                    {contact.intro}
                </Typography>

                <Stack spacing={2.5}>
                    <Box>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: '#ff751f',
                                fontWeight: 700,
                                mb: 0.5
                            }}
                        >
                            Phone
                        </Typography>
                        <Link
                            href={`tel:${practice.phone}`}
                            underline="hover"
                            sx={{
                                color: '#00476e',
                                fontSize: '1rem',
                                fontWeight: 500
                            }}
                        >
                            {practice.phone}
                        </Link>
                    </Box>

                    <Box>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: '#ff751f',
                                fontWeight: 700,
                                mb: 0.5
                            }}
                        >
                            Email
                        </Typography>
                        <Link
                            href={`mailto:${practice.email}`}
                            underline="hover"
                            sx={{
                                color: '#00476e',
                                fontSize: '1rem',
                                fontWeight: 500
                            }}
                        >
                            {practice.email}
                        </Link>
                    </Box>

                    <Box>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: '#ff751f',
                                fontWeight: 700,
                                mb: 0.5
                            }}
                        >
                            Instagram
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                        >
                            <Link
                                href={contact.instagramUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="none"
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    color: '#00476e'
                                }}
                            >
                                <InstagramIcon
                                    sx={{
                                        color: '#00476e',
                                        fontSize: 22
                                    }}
                                />
                            </Link>
                            <Link
                                href={contact.instagramUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                sx={{
                                    color: '#00476e',
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }}
                            >
                                {contact.instagramHandle}
                            </Link>
                        </Box>
                    </Box>

                    <Box>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: '#ff751f',
                                fontWeight: 700,
                                mb: 0.5
                            }}
                        >
                            Facebook
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                        >
                            <Link
                                href={contact.facebookUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="none"
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    color: '#00476e'
                                }}
                            >
                                <FacebookIcon
                                    sx={{
                                        color: '#00476e',
                                        fontSize: 22
                                    }}
                                />
                            </Link>
                            <Link
                                href={contact.facebookUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                sx={{
                                    color: '#00476e',
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }}
                            >
                                {contact.facebookLabel}
                            </Link>
                        </Box>
                    </Box>

                    <Box>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: '#ff751f',
                                fontWeight: 700,
                                mb: 0.75
                            }}
                        >
                            Availability Note
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                color: 'rgba(0, 71, 110, 0.78)',
                                lineHeight: 1.8
                            }}
                        >
                            {contact.availabilityNote}
                        </Typography>
                    </Box>
                </Stack>
            </SectionCard>

            <Box sx={splitRowSx}>
                <Box
                    sx={{
                        width: { xs: '100%', md: '25%' },
                        flexShrink: 0,
                        display: 'flex'
                    }}
                >
                    <SectionCard title={contact.hoursTitle} sx={{ width: '100%' }}>
                        <Stack spacing={2}>
                            <Box>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        color: '#ff751f',
                                        fontWeight: 700,
                                        mb: 0.5
                                    }}
                                >
                                    {contact.phoneHoursTitle}
                                </Typography>
                                <Typography
                                    sx={{
                                        color: 'rgba(0, 71, 110, 0.78)',
                                        lineHeight: 1.8
                                    }}
                                >
                                    {contact.phoneHours}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        color: '#ff751f',
                                        fontWeight: 700,
                                        mb: 0.5
                                    }}
                                >
                                    {contact.sessionHoursTitle}
                                </Typography>
                                <Typography
                                    sx={{
                                        color: 'rgba(0, 71, 110, 0.78)',
                                        lineHeight: 1.8
                                    }}
                                >
                                    {contact.sessionHours}
                                </Typography>
                            </Box>
                        </Stack>
                    </SectionCard>
                </Box>

                <Box
                    sx={{
                        width: { xs: '100%', md: '75%' },
                        display: 'flex'
                    }}
                >
                    <SectionCard sx={{ width: '100%' }}>
                        <Box sx={{ mb: 2.5 }}>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(0, 71, 110, 0.78)',
                                    lineHeight: 1.8
                                }}
                            >
                                {contact.formIntroBody}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                borderRadius: 3,
                                overflow: 'hidden',
                                backgroundColor: '#ffffff',
                                border: '1px solid rgba(0, 71, 110, 0.10)'
                            }}
                        >
                            <Box
                                component="iframe"
                                src="https://docs.google.com/forms/d/e/1FAIpQLScZvf9NrykUo_Umo9vUAaqZmmWl6jzgNIg0b8vLHahxCm_F9g/viewform?embedded=true"
                                title="Contact Form"
                                sx={{
                                    display: 'block',
                                    width: '100%',
                                    height: { xs: 1900, md: 1750 },
                                    border: 0,
                                    backgroundColor: '#ffffff'
                                }}
                            />
                        </Box>
                    </SectionCard>
                </Box>
            </Box>
        </Container>
    );
};

export default Contact;